import {onDomChanges, onDomReady} from "../../components/dynamic/observer";
import {singleBind} from "../../components/dynamic/bind";

function toggleToCompare(e) {
    const button = this;
    if (!button.dataset.compareSelected) {
        button.classList.add('to-compare_selected');

        document.dispatchEvent(new CustomEvent('compareAdd', {
            detail: {
                chosen: button.dataset.chosen,
                id: parseInt(button.dataset.id),
                type: button.dataset.type,
                chosenType: button.dataset.chosenType
            }
        }));
    } else {
        button.classList.remove('to-compare_selected');

        let removingItem = document.querySelector(`[data-compare-selected="${button.dataset.compareSelected}"]`);
        if (removingItem.closest('.compare-page__item')) {
            removingItem.closest('.compare-page__item').remove();
        }

        document.dispatchEvent(new CustomEvent('compareRemove', {
            detail: {
                key: button.dataset.compareSelected,
                chosenType: button.dataset.chosenType
            }
        }));
    }
}

onDomChanges(() => {
    document.querySelectorAll('[data-compare-toggle]').forEach((link) => {
        singleBind(link, 'initialized', 'click', toggleToCompare);
    });
});